import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../config';
import './CSVImport.css';

function CSVImport({ onClose, onImportComplete }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
    setResult(null);
  };

  const parseCSV = (text) => {
    const lines = text.split('\n');
    const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));

    const data = [];
    for (let i = 1; i < lines.length; i++) {
      if (lines[i].trim() === '') continue;

      const values = [];
      let current = '';
      let inQuotes = false;

      for (let char of lines[i]) {
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          values.push(current.trim().replace(/^"|"$/g, '').replace(/""/g, '"'));
          current = '';
        } else {
          current += char;
        }
      }
      values.push(current.trim().replace(/^"|"$/g, '').replace(/""/g, '"'));

      const row = {};
      headers.forEach((header, index) => {
        const key = header.toLowerCase().replace(/\s+/g, '_').replace(/[^\w_]/g, '');
        row[key] = values[index] || '';
      });

      data.push(row);
    }

    return data;
  };

  const handleImport = async () => {
    if (!file) {
      setError('Please select a CSV file');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const text = await file.text();
      const csvData = parseCSV(text);

      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/clients/import/csv`,
        { csvData },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setResult(response.data);
      if (response.data.imported > 0) {
        setTimeout(() => {
          onImportComplete();
          onClose();
        }, 2000);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error importing CSV');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content csv-import" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Import Clients from CSV</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="import-body">
          <div className="import-instructions">
            <h3>CSV Format</h3>
            <p>Your CSV file should have the following columns (in any order):</p>
            <ul>
              <li>Name (required)</li>
              <li>Service Type</li>
              <li>Linehaul or P&D</li>
              <li>Phone Number</li>
              <li>Company</li>
              <li>Email</li>
              <li>Location</li>
              <li>Current</li>
              <li>Status</li>
              <li>Call Date</li>
              <li>Call Notes</li>
              <li>Onboarding Date</li>
              <li>Recruiting Start Tasks</li>
              <li>Current Provider</li>
              <li>State</li>
              <li>City</li>
              <li>Station</li>
            </ul>
          </div>

          <div className="file-upload">
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              disabled={loading}
            />
            {file && <p className="file-name">Selected: {file.name}</p>}
          </div>

          {error && <div className="error-message">{error}</div>}

          {result && (
            <div className="success-message">
              <p>✓ Successfully imported {result.imported} clients!</p>
              {result.errors && result.errors.length > 0 && (
                <div className="import-errors">
                  <p>Errors:</p>
                  <ul>
                    {result.errors.slice(0, 10).map((err, i) => (
                      <li key={i}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          <div className="import-actions">
            <button onClick={onClose} className="btn-secondary" disabled={loading}>
              Cancel
            </button>
            <button onClick={handleImport} className="btn-primary" disabled={loading || !file}>
              {loading ? 'Importing...' : 'Import'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CSVImport;
